<template>
<div>
	<b-navbar class="submenu">
		<b-container>
			<b-navbar-brand href="#">Customer Admin</b-navbar-brand>
			<b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
			<b-collapse id="nav-collapse" is-nav>
				<b-navbar-nav>
				
				</b-navbar-nav>
			</b-collapse>
		</b-container>
	</b-navbar>
	<div id="content">
		<b-overlay :show="this.working" rounded="sm">
			<div class="row">
				<div class="col-md-3">
					<b-form-input placeholder="search" class="mb-2" v-model="search"></b-form-input>
					<div class="leftSide">
						<b-table :filter="search" striped hover small :items="customers" selectable select-mode="single" :fields="['customers', 'linked']" @row-clicked="onCustomerSelected"></b-table>					
					</div>
				</div>
				<div class="col-md-8 m-3 mt-0" v-if="customer">
					<div class="row mb-2">
						<h4>{{customer.id}}</h4>
					</div>
					<div class="row mb-2">
						<div class="col-md-4">
							Title: <b-form-input readonly class="mb-2" v-model="customer.person.title"></b-form-input>
						</div>
						<div class="col-md-4">
							First Name: <b-form-input readonly class="mb-2" v-model="customer.person.firstName"></b-form-input>
						</div>
						<div class="col-md-4">
							Last Name: <b-form-input readonly class="mb-2" v-model="customer.person.lastName"></b-form-input>
						</div>
					</div>
					<div class="row mb-2">
						<div class="col-md-4">
							Email: <b-form-input readonly class="mb-2" v-model="customer.person.email"></b-form-input>
						</div>
						<div class="col-md-4">
							Mobile: <b-form-input readonly class="mb-2" v-model="customer.person.mobilePhone"></b-form-input>
						</div>
						<div class="col-md-4">
							DOB: <b-form-input readonly class="mb-2" v-model="customer.person.dob"></b-form-input>
						</div>
					</div>
					<div class="row mb-2" v-if="customer.employerID">
						<div class="col-md-4">
							Employer: <b-form-input readonly class="mb-2" v-model="customer.employer.name"></b-form-input>
						</div>
					</div>
					<div class="row mb-2" v-if="customer.employerID == null">
						<div class="col-md-4">
							Employer: <b-form-input readonly class="mb-2" v-model="customer.employerId"></b-form-input>
						</div>
						<div class="col-md-4">
							<br/>
							<b-button size="sm" v-b-modal.modal-emp>Link Employer</b-button>
							<b-modal id="modal-emp" title="Select Employer">
								<b-form-input placeholder="search" class="mb-2" v-model="employerSearch"></b-form-input>
								<b-table :filter="search" striped hover small :items="employers" selectable :fields="['name']" @row-clicked="selectEmployer"></b-table>
							</b-modal>
						</div>
					</div>	
					<div class="row mb-2">
						<div class="col-md-12">
							Signed Up: {{customer.createDateTime}}<br/>
							Last Logged In: {{customer.lastLoginDateTime}}<br/>
						</div>
					</div>
					<b-alert class="mt-3" show variant="danger">
						<strong>I have obtained explicit permission from the customer to view their details.</strong> <br/>
						<small>Section 170 of the Data Protection Act 2018 (DPA 2018) makes it a criminal offense to unlawfully obtain personal data.</small>
						<b-form-checkbox class="mb-2" v-model="permission"></b-form-checkbox>
					</b-alert>
					<div v-if="permission">
						<div class="row mb-2" v-if="insurance && insurance.length > 0">
							<div class="col-md-12">
								Insurance: {{insurance.length}}<br/><br/>
								<b-table striped hover small :items="insurance" :fields="[{key:'provider.name', label:'Provider'}, {key:'policyType.name', label:'Type'}, 'policyNumber', {key:'insuredItems[0].vehicleRegistration', label:'Reg'}, {label: 'Details', key:'showDetails', sortable:false}]">
									<template #cell(showDetails)="row">
										<b-button size="sm" variant="link" @click="row.toggleDetails" class="mr-2">
											<b-icon icon="three-dots" />
										</b-button>
									</template>
									<template #row-details="row">
										<b-card>
											<b-row>
												<b-col>
													<p>AIOP Object:</p>
													<code>
														{{ row.item }}
													</code>
												</b-col>
											</b-row>
										</b-card>
									</template>
								</b-table>
							</div>
						</div>
						<div class="row mb-2" v-if="investments && investments.length > 0">
							<div class="col-md-12">
								Investments: {{investments.length}}<br/><br/>
								<b-table striped hover small :items="investments" :fields="[{key:'provider.name', label:'Provider'}, {key:'accountType.name', label:'Type'}, 'accountNumber', {label: 'Details', key:'showDetails', sortable:false}]">
									<template #cell(showDetails)="row">
										<b-button size="sm" variant="link" @click="row.toggleDetails" class="mr-2">
											<b-icon icon="three-dots" />
										</b-button>
									</template>
									<template #row-details="row">
										<b-card>
											<b-row>
												<b-col>
													<p>AIOP Object:</p>
													<code>
														{{ row.item }}
													</code>
												</b-col>
											</b-row>
										</b-card>
									</template>
								</b-table>
							</div>
						</div>
						<div class="row mb-2" v-if="moves && moves.length > 0">
							<div class="col-md-12">
								Pending moves: {{moves.length}}<br/><br/>
								<b-table striped hover small :items="moves" :fields="['pendingMoves', 'description']"></b-table>
							</div>
						</div>
						<br/>
						<div class="row mb-2" v-if="customer.facts">
							<h4>Fact Card</h4>
							<div class="col-md-12">
								<table>
									<tr v-for="(value, name) in customer.facts" :key="name">
										<td>{{ name }}</td><td><b-form-input v-model="customer.facts[name]"></b-form-input></td> 
									</tr>
								</table>
								<b-button v-b-modal.modal-emp @click="postFactCard">Generate Moves</b-button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</b-overlay>
	</div>
</div>
</template>
<script>
export default {
  name: 'Stats',
  data() {
	return{
		customers: null,
		employers: null,
		customer: null,
		search:"",
		employerSearch:"",
		selfId: null,
		moves: null,
		insurance: null,
		working: true,
		permission: false
	}
  },
  methods: {
	getCustomers: function(){
		this.working = true;
		this.$http.get(this.$config.ApiUri + "/Customers")
			.then((result) => {
				this.customers = result.data;
				for (var x = 0; x< this.customers.length; x++)
				{
					this.customers[x].customers = this.customers[x].person.firstName 
						+ " " + this.customers[x].person.lastName
					this.customers[x].linked = this.customers[x].employerID != null;
					this.working = false;
				}
			}
		)
	},
	getEmployers: function(){
		this.working = true;
		this.$http.get(this.$config.ApiUri + "/Employers")
			.then((result) => {
				this.employers = result.data;
				this.working = false;
			}
		)
	},
	getSelf: function() {
		this.$http.get(this.$config.ApiUri + "/Customers/00000000-0000-0000-0000-000000000000")
			.then((result) => {
				this.selfId = result.data.id;
			}
		)
	},
	onLoad() {
		this.getSelf();
		this.getCustomers();
		this.getEmployers();
	},
	getInsurance: function(id) {
		this.$http.get(this.$config.ApiUri + "/Customers/" + id + "/Policies")
			.then((result) => {
				this.insurance = result.data;
				for(var x = 0; x < this.insurance.length; x++) {
					this.insurance[x].showDetails = true;
				}
			}
		)
	},
	getInvestments: function(id) {
		this.$http.get(this.$config.ApiUri + "/Customers/" + id + "/InvestmentHubAccounts")
			.then((result) => {
				this.investments = result.data;
				for(var x = 0; x < this.investments.length; x++) {
					this.investments[x].showDetails = true;
				}
			}
		)
	},
	selectCustomer(c){
		this.working = true;
		this.customer = c;
		this.permission = false;
		var getFacts = this.selfId == c.id;
		this.$http.get(this.$config.ApiUri + "/Customers/" + c.id + "?getEmployer=true&getFacts=" + getFacts)
			.then((result) => {
				this.customer = result.data;
				this.$http.get(this.$config.ApiUri + "/Customers/" + this.customer.id + "/Moves")
					.then((result) => {
						this.moves = result.data;
						for(var x = 0; x < this.moves.length; x++) { this.moves[x].pendingMoves = this.moves[x].title; }
						this.getInsurance(c.id);
						this.getInvestments(c.id);
						this.working = false;
					}
				)
			}
		)
	},
	postFactCard: function() {
		//this.$config.ApiUri = "http://localhost:5000"
		this.working = true;
		var facts = new Array();
		for (var key in this.customer.facts) {
			facts.push({ "name": key, "value": this.customer.facts[key] });
		}
		this.$http.post(this.$config.ApiUri + "/Customers/" + this.customer.id + "/FactCard", facts)
			.then(() => {
				this.$http.post(this.$config.ApiUri + "/Moves/GenerationRequests?customerId=" + this.selfId, null)
					.then(() => {
						this.$http.get(this.$config.ApiUri + "/Customers/" + this.selfId + "?getEmployer=true&getFacts=true")
							.then((result) => {
								this.customer = result.data;
								this.$http.get(this.$config.ApiUri + "/Customers/" + this.customer.id + "/Moves")
									.then((result) => {
										this.moves = result.data;
										for(var x = 0; x < this.moves.length; x++) { this.moves[x].pendingMoves = this.moves[x].title; }
										this.working=false;
									}
								)
							}
						)
					}
				)
			}
		)
	},
	selectEmployer(e){
		this.working = true;
		this.employer = e;
		this.$http.post(this.$config.ApiUri + "/Customers/" + this.customer.id + "/LinkToEmployerRequests?employerId=" + e.id, null)
			.then(() => {
				this.$http.get(this.$config.ApiUri + "/Customers/" +  this.customer.id + "?getEmployer=true")
					.then((result) => {
						this.customer = result.data;
						this.working = false;
					}
				)
			}
		)
	},
	onCustomerSelected(record)
	{
		this.selectCustomer(record);
	}
  },
  mounted: function() { this.onLoad(); }
}
</script>